import { colorStrings, fontFamily, fontFamilyHeader, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import baseTheme from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const datePicker: RecursivePartial<{
    defaultProps?: DatePickerPresentationProps | undefined;
}> = {
    defaultProps: {
        cssOverrides: {
            datePicker: css`
                width: 100%;

                .react-calendar__navigation {
                    margin-bottom: 16px;
                }

                .react-calendar button {
                    min-height: 40px;
                    border-radius: 42px;
                    color: ${getColor(colorStrings.textMain)};

                    &:not(.react-calendar__navigation) {
                        font-family: ${fontFamily};
                        font-size: 12px;
                        line-height: 16px;
                    }

                    &.react-calendar__navigation__next-button,
                    &.react-calendar__navigation__prev-button {
                        background-image: none;
                        font-size: 40px;
                        width: 10px;
                        height: 10px;
                        color: ${getColor(colorStrings.primaryMain)};
                        padding-block-end: 10px;
                    }

                    &:enabled:focus:not(:disabled) {
                        background-color: transparent;
                        color: ${getColor(colorStrings.textMain)};
                        span {
                            outline: none;
                        }
                    }

                    &:enabled:hover:not(:disabled) {
                        background-color: #ade8f4;
                    }

                    &.react-calendar__tile--active:not(:disabled),
                    &.react-calendar__tile--hasActive:not(:disabled) {
                        background-color: ${getColor(colorStrings.primaryMain)};
                        color: ${getColor(colorStrings.commonGlobalWhite)};

                        &:hover {
                            color: ${getColor(colorStrings.commonGlobalWhite)};
                            background-color: ${getColor(colorStrings.primaryMain)};
                        }
                    }

                    &.react-calendar__tile--now {
                        color: ${getColor(colorStrings.secondaryMain)};
                        font-weight: 700;
                    }
                }

                .react-calendar__navigation__label__labelText {
                    ${baseTheme.typography.h4.css}
                    font-family: ${fontFamilyHeader};
                    font-size: 16px;
                    line-height: 19.2px;
                    text-transform: uppercase;
                    margin-bottom: 0;

                    ${mediaQueriesBP.minMD} {
                        font-size: 24px;
                        line-height: 30px;
                    }
                }
            `,
        },
        calendarIconProps: {
            css: css`
                width: 20px;
                height: 20px;
                ${mediaQueriesBP.minMD} {
                    width: 30px;
                    height: 30px;
                }
            `,
        },
    },
};
